<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card elevation="3" rounded="xxl">
            <v-card-title>
              <h3 class="font-weight-bold">Sale Order Cancellation Logs</h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    solo
                    rounded
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card elevation="3" rounded="xxl">
            <v-card-text>
              <v-simple-table class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th
                        class="text-start font-weight-bold text-subtitle-2 sr_no"
                      >
                        Sr No
                      </th>
                      <th
                        class="text-start font-weight-bold text-subtitle-2 sr_no"
                      >
                        Status
                      </th>
                      <th
                        class="text-start font-weight-bold text-subtitle-2 sr_no"
                      >
                        Incoice
                      </th>
                      <th
                        class="text-start font-weight-bold text-subtitle-2 sr_no"
                      >
                        Transporter Name
                      </th>
                      <th
                        class="text-start font-weight-bold text-subtitle-2 sr_no"
                      >
                        Driver Name
                      </th>
                      <th
                        class="text-start font-weight-bold text-subtitle-2 sr_no"
                      >
                        Description
                      </th>
                      <th
                        class="text-start font-weight-bold text-subtitle-2 sr_no"
                      >
                        Cancel By
                      </th>
                      <th
                        class="text-start font-weight-bold text-subtitle-2 sr_no"
                      >
                        Cancellation Date
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="cancellation_logs.length != 0">
                    <tr v-for="(log, i) in cancellation_logs" :key="`log_${i}`">
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="error"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Cancelled
                            </v-chip>
                          </template>
                          <span>SaleOrder Cancelled</span>
                        </v-tooltip>
                      </td>
                      <td>{{ log.sale ? log.sale.invoice_no : "" }}</td>
                      <td>
                        {{
                          log.sale && log.sale.user
                            ? log.sale.user.first_name
                            : ""
                        }}
                      </td>

                      <td>
                        {{
                          log.sale && log.sale.driver
                            ? log.sale.driver.first_name
                            : ""
                        }}
                      </td>

                      <td>{{ log.description }}</td>
                      <td>
                        {{
                          log.sale && log.sale.created_by
                            ? log.sale.created_by.first_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{ log.created_at ? log.created_at : "" }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "CancellationLogsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
      },
      cancellation_logs: [],
      count: 0,
      isLoading: false,
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
    };
  },
  mounted() {
    this.getCancelLogs();
  },
  methods: {
    async getCancelLogs() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`sale_order_cancellation_logs?${query}`)
        .then((response) => {
          this.cancellation_logs = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.log(error);
        });
      this.isLoading = false;
      console.log(this.cancellation_logs);
    },
  },
};
</script>
